import { ReactNode } from 'react';
import { IoInformationCircleOutline } from 'react-icons/io5';
import './TagSelector.scss';

export interface TagOption {
  value: string;
  label: string;
}

type TagColor = 'blue' | 'green' | 'purple' | 'teal';
type TagSize = 'default' | 'big';

interface TagSelectorProps {
  title: ReactNode;
  options: readonly TagOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  color?: TagColor;
  size?: TagSize;
  onInfoClick?: () => void;
}

export function TagSelector({ title, options, selected, onChange, color = 'blue', size = 'default', onInfoClick }: TagSelectorProps) {
  const handleClick = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const handleSelectAll = () => {
    onChange(options.map(o => o.value));
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const allSelected = selected.length === options.length;
  const noneSelected = selected.length === 0;

  return (
    <div className={`tag-selector ${size === 'big' ? 'tag-selector--big' : ''}`}>
      <div className="tag-selector__header">
        <div className="tag-selector__title">
          {title}
          {onInfoClick && (
            <button type="button" className="tag-selector__info" onClick={onInfoClick}>
              <IoInformationCircleOutline />
            </button>
          )}
        </div>
        <div className="tag-selector__actions">
          {!allSelected && (
            <button type="button" className="tag-selector__action" onClick={handleSelectAll}>
              Select All
            </button>
          )}
          {!noneSelected && (
            <button type="button" className="tag-selector__action" onClick={handleClearAll}>
              Clear
            </button>
          )}
        </div>
      </div>
      <div className="tag-selector__tags">
        {options.map(option => (
          <button
            key={option.value}
            type="button"
            className={`tag-selector__tag tag-selector__tag--${color} ${selected.includes(option.value) ? 'tag-selector__tag--selected' : ''}`}
            onClick={() => handleClick(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
